export default __webpack_public_path__ + "components/weather-icon/static/daycloud-81336e7e68b70eb7c054b8afb90c4c36.png";